import React from "react";

export const wrapRootElement = ({ element }) => (
  <>
    {element}
  </>
);
